import { render, staticRenderFns } from "./DisplayExport.vue?vue&type=template&id=2969f34a&scoped=true&"
import script from "./DisplayExport.vue?vue&type=script&lang=js&"
export * from "./DisplayExport.vue?vue&type=script&lang=js&"
import style0 from "./DisplayExport.vue?vue&type=style&index=0&id=2969f34a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969f34a",
  null
  
)

export default component.exports